import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';


export class RoleProductQuota extends BaseEntity {

  role              : Role    = new Role();
  product           : Product = new Product();
  assignedQuantity  : number;
  rate              : number;

  constructor() {
    super();
  }

}